import { BUILD_TIME, VERSION } from '../define-envs';
import { PLAY_MODE } from '../enums';
import { videoTool } from '../util';
import LivePlayer from './live-player';
import MultiPlayer from './multi-player';
/**
 * 原生内核播放器，vod为multiplayer，live为liveplayer
 */
var OrgPlayer = /** @class */ (function () {
    function OrgPlayer(opts) {
        return opts.type === PLAY_MODE.LIVE ? new LivePlayer(opts) : new MultiPlayer(opts);
    }
    Object.defineProperty(OrgPlayer, "canPlayType", {
        get: function () {
            return videoTool.supportVideoFormat();
        },
        enumerable: false,
        configurable: true
    });
    OrgPlayer.isEnvSupport = true;
    OrgPlayer.VERSION = VERSION;
    OrgPlayer.BUILD_TIME = BUILD_TIME;
    return OrgPlayer;
}());
export default OrgPlayer;
;
